<template>
	<div class="tw-flex tw--mx-3">
		<div class="px-3 tw-w-3/5">
			<model-stepper
				:current-step="4"
				class="tw-mb-4"
				@code-step="loadCodeStep">
			</model-stepper>
			<p-card class="tw-mb-4">
				<div class="tw-px-5">
					<span :style="`color:${$appColors.info}`">
						<b style>Puesto Seleccionado: </b> {{ selectedJobs.name }}
					</span>
				</div>
			</p-card>
			<p-card class="interview-list">
				<div class="tw-text-bold interview-list-header tw-py-1 tw-mb-4 tw-flex tw-justify-center">
					<span>Configura las preguntas de la entrevista personal</span>
				</div>
				<section class="subfactors-list tw-flex tw-flex-col" v-if="interview.length !== 0">
					<subfactor-item
						class="tw-mb-4"
						v-for="(subfacItem, index) in interview"
						:key="index"
						:sub-item="subfacItem"
						:tool-tip="validateTotalEx"
						@updateSubFactorItem="handlerUpdateSubFactor($event)">
					</subfactor-item>
				</section>
				<p-horizontal-divider/>
				<div class="tw-flex tw-justify-center tw-gap-x-4">
					<p-button
						type="secondary"
						@click="returnConfigProcess">Atrás</p-button>
					<p-button
						type="primary"
						:disabled="verifySubfactorsQuestions || validateValues || validateTotalEx || validateTotalNA"
						@click="saveTemplateInterview">Guardar Plantilla</p-button>
				</div>
			</p-card>
		</div>
		<div class="px-3 tw-w-2/5 fixed-section">
			<model-description
				:title="'PROCESO DE SELECCIÓN'"
				v-if="Object.keys(dataStepActivities).length > 0">
				<div class="tw-mt-0 tw-mb-11 tw-flex tw-flex-col tw-text-center tw-justify-center tw-items-center" slot="content">
					<div class="">
						El puntaje de esta entrevista es: <span style="font-weight: bold;">{{ dataStepActivities.details[0].score }} puntos</span>
					</div>
					<div class="tw-w-full tw-my-4">
						<table class="table-eqivalences">
							<tr>
								<th></th>
								<th :style="`color:${$appColors.secondary};`">NA</th>
								<th :style="`color:${$appColors.secondary};`">Bx</th>
								<th :style="`color:${$appColors.secondary};`">Sx</th>
								<th :style="`color:${$appColors.secondary};`">Ex</th>
							</tr>
							<tr v-for="(subfactor, indexI) in interview">
								<td :key="indexI" :style="`padding: 5px; color:; text-align: left; padding-left: 10px;`">{{ subfactor.description }}</td>
								<td style="width: 40px;"  v-for="(equivalence, indexE) in subfactor.equivalences" :key="indexE">
									{{ equivalence.value }}
								</td>
							</tr>
							<tr>
								<td :style="`padding: 5px 0 5px 10px; color:${$appColors.primary}; text-align: left;`">TOTALES</td>
								<td :style="validateTotalNA ? `color:${$appColors.error}; padding: 5px;` : `color:${$appColors.primary}; padding: 5px;`">{{ totalValues.totalNAValue }}%</td>
								<td :style="`color:${$appColors.primary}; padding: 5px;`">{{ totalValues.totalBxValue }}%</td>
								<td :style="`color:${$appColors.primary}; padding: 5px;`">{{ totalValues.totalSxValue }}%</td>
								<td :style="validateTotalEx ? `color:${$appColors.error}; padding: 5px;` : `color:${$appColors.primary}; padding: 5px;`">{{ totalValues.totalExValue }}%</td>
							</tr>
						</table>
					</div>
					<div class="tw-mb-12 tw-text-left">
						<h3 :style="`color:${$appColors.secondary};`">Equivalencias</h3>
						NA = No Aceptable<br>
						Bx = Bajo al Promedio<br>
						Sx = Superior al Promedio<br>
						Ex = Excelente
					</div>
					<p-button
						type="primary"
					>Mire nuestro tutorial paso a paso</p-button>
				</div>
			</model-description>
		</div>
	</div>
</template>

<script>
import modelStepper from '@/modules/recruitment/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import SquareBox from '@/modules/shared/components/content/SquareBox';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import subfactorItem from '@/modules/recruitment/components/content/subfactor-item';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';
import { updateSubFactorsList } from '@/modules/recruitment/utils/listElements';

const { getLocalData } = helper;

export default {
	name: 'step-config-template-interview',
	components: {
		modelStepper,
		PCard,
		SquareBox,
		modelDescription,
		PButton,
		PHorizontalDivider,
		subfactorItem,
	},
	data() {
		return {
			codeStep: {},
			interviewData: {},
			interview: {},
			dataStepActivities: {},
		};
	},
	methods: {
		async loadData() {
			try {
				if (this.codeStep) {
					const { data: response } = await this.$httpPraktiko.get(`/recruitment/detail/${this.codeStep.code}/${this.idConfigProcess}`);
					const { data: responseStepFactors } = await this.$httpPraktiko.get(`/recruitment/detail/CAR/${this.idConfigProcess}`);
					this.dataStepActivities = responseStepFactors;
					if (response) {
						const mergeArrays = response.details.subFactors
							.filter(obj1 => responseStepFactors.details[0].subFactors
								.some(obj2 => obj1.code === obj2.code));
						responseStepFactors.details[0].subFactors.forEach((obj2) => {
							if (!mergeArrays.some(obj1 => obj1.code === obj2.code)) {
								mergeArrays.push(obj2);
							}
						});
						this.interview = mergeArrays;
					} else {
						this.interviewData = responseStepFactors.details[0];
						this.interview = responseStepFactors.details[0].subFactors;
					}
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		loadCodeStep(obj) {
			this.codeStep = obj;
		},
		returnConfigProcess() {
			this.goTo(this.codeStep.returnTo);
		},
		async saveTemplateInterview() {
			const body = {
				id: this.idConfigProcess,
				typeRecruitmentCode: this.codeStep.code,
				jobId: this.selectedJobs.id,
				details: {
					name: this.interviewData.name,
					score: this.interviewData.score,
					flagInterview: this.interviewData.flagInterview,
					subFactors: this.interview,
				},
			};
			try {
				await this.$httpPraktiko.post('/recruitment', body);
				this.showNotification('Actividades Guardadas Exitosamente');
				this.$store.dispatch('recruitment/saveIdConfigProcess');
				this.$store.dispatch('recruitment/toggleJobSelection');
				this.goTo(this.codeStep.goTo);
			} catch (error) {
				this.showGenericError();
			}
		},
		handlerUpdateSubFactor(subFactor) {
			this.interview = updateSubFactorsList(
				subFactor,
				this.interview,
			);
		},
		computeTotalValue(code) {
			if (Object.keys(this.interview).length > 0) {
				return this.interview.map(subF =>
					subF.equivalences.reduce((acum, eq) => {
						if (eq.code === code) {
							return acum + Number(eq.value);
						}
						return acum;
					}, 0),
				).reduce((acum, value) => acum + value, 0);
			}
			return 0;
		},
	},
	computed: {
		...mapState('recruitment', {
			selectedJobs(state) {
				return pathOr(getLocalData('jobSelected'), ['recruitmentFlow', 'selectedJobs'], state.recruitment) || [];
			},
			idConfigProcess(state) {
				return pathOr(getLocalData('idConfigProcess'), ['idConfigProcess'], state.recruitment) || [];
			},
		}),
		verifySubfactorsQuestions() {
			if (this.interview.length > 0) {
				const validate = this.interview.some(item => item.questions.length === 0);
				return validate;
			}
			return false;
		},
		validateValues() {
			if (this.interview.length > 0) {
				return this.interview.some((item) => {
					let valoresVacios = false;
					item.equivalences.forEach((equivalence) => {
						if (equivalence.value === null || equivalence.value === '') {
							valoresVacios = true;
						}
					});
					return valoresVacios;
				});
			}
			return false;
		},
		totalValues() {
			return {
				totalExValue: this.computeTotalValue('Ex'),
				totalSxValue: this.computeTotalValue('Sx'),
				totalBxValue: this.computeTotalValue('Bx'),
				totalNAValue: this.computeTotalValue('NA'),
			};
		},
		validateTotalEx() {
			if (this.totalValues.totalExValue > 100) {
				return true;
			} else if (this.totalValues.totalExValue < 100) {
				return true;
			}
			return false;
		},
		validateTotalNA() {
			if (this.totalValues.totalNAValue !== 0) {
				return true;
			}
			return false;
		},
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},

	},
};
</script>

<style lang="scss" scoped>
.interview-list {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
}
.subfactors-list {
	overflow: auto;
	height: 70vh;
}
.table-eqivalences {
	width: 100%;
	td {
		border-bottom: 1px solid color(placeholder);
	}
}
.fixed-section {
	width: 30% !important;
	position: fixed;
	right: 95px;
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/steps-recruitment/step-config-template-interview.vue